import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { LeavePolicy } from '../types/leave';

interface LeavePoliciesState {
  leavePolicies: LeavePolicy[];
}

const initialState: LeavePoliciesState = {
  leavePolicies: [],
};

const leavePoliciesSlice = createSlice({
  name: 'leavePolicies',
  initialState,
  reducers: {
    setLeavePolicies(state, action: PayloadAction<LeavePolicy[]>) {
      state.leavePolicies = action.payload;
    },
    upsertLeavePolicy(state, action: PayloadAction<LeavePolicy>) {
      const idx = state.leavePolicies.findIndex(
        (p) => p.leaveTypeId === action.payload.leaveTypeId && p.effectiveDate === action.payload.effectiveDate,
      );
      if (idx !== -1) {
        state.leavePolicies[idx] = action.payload;
      } else {
        state.leavePolicies.push(action.payload);
      }
    },
  },
});

export const { setLeavePolicies, upsertLeavePolicy } = leavePoliciesSlice.actions;
export default leavePoliciesSlice.reducer;
